import { render } from "./_organization.vue?vue&type=template&id=03c24904"
import script from "./_organization.vue?vue&type=script&lang=js"
export * from "./_organization.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__